const removeCharacter = (text: string, position: number): string => {
  const part1 = text.substring(0, position)
  const part2 = text.substring(position + 1, text.length)

  return part1 + part2
}

export const removeTextTag = (elementId: string): void => {
  const element: HTMLElement | null = document.getElementById(elementId)
  const isElement = (input: HTMLElement | null): input is HTMLElement => input !== null

  if (isElement(element)) {
    const inputValue = document.getElementById(elementId) as HTMLInputElement

    const isElementInput = (input: HTMLInputElement | null): input is HTMLInputElement => input !== null

    if (isElementInput(inputValue)) {
      const currentPosition: number | null = inputValue.selectionStart
      inputValue.value = removeCharacter(inputValue.value, (currentPosition as number) - 1)
    }
  }
}

export const clearTextTag = (elementId: string): void => {
  const element: HTMLElement | null = document.getElementById(elementId)
  const isElement = (input: HTMLElement | null): input is HTMLElement => input !== null

  if (isElement(element)) {
    const inputValue = document.getElementById(elementId) as HTMLInputElement

    const isElementInput = (input: HTMLInputElement | null): input is HTMLInputElement => input !== null

    if (isElementInput(inputValue)) {
      inputValue.value = ''
    }
  }
}

export const numericOnly = (event: any): boolean => {
  const key = event.nativeEvent.data
  const reg = /^-?\d+\.?\d*$\b/

  if (!event.nativeEvent.inputType) {
    return false
  }

  if (event.nativeEvent.inputType === 'deleteContentBackward') {
    return true
  }

  return reg.test(key) !== false
}

export const alphaOnly = (event: any): boolean => {
  const key = event.nativeEvent.data
  const reg = /^[a-z˜ñÑ.\-\b\s]+$/i

  if (!event.nativeEvent.inputType) {
    return false
  }

  return reg.test(key) !== false
}

export const alphaNumericWithSpecialCharacters = (event: any): boolean => {
  const key = event.target.value
  const reg = /[^a-zA-Z0-9.,?!\b.\s]/

  return reg.test(key) === false
}

export const preventInput = (event: any): void => {
  event.preventDefault()
}
